// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2znFI"};
    if(module.hot) {
      // 1790670315640
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  